
export const BG_ENDPOINTS = {
    ApiKey: 'ij07p2iavC7ryC7mZkRuAIsQoogDMii62t1S7Jr6', // NOTE: Replace with your API Gateway key value
    Endpoint: 'https://5ynlg0gh35.execute-api.us-east-1.amazonaws.com/prod', // NOTE: Replace with the URL of your API service endpoint
    Resources : ['get_requests', 'get_pending_requests', 'get_processed_requests', 'get_all_requests', 'create_request', 'delete_request', 'approve_request', 'reject_request', 'update_request_url', 'federate_console', 'federate_cli']
};